export default {
  staking: {
    //
  }
}
